import {
    REQUEST_SUPPLIERS,
    RECEIVE_SUPPLIERS,
    UPDATE_SUPPLIERS,
    ERROR_SUPPLIERS
} from '../types'
import {fetchUrl} from '../../constants/constants'
import {requestItem, receiveItem, failedItem} from "../actions"
import fetchErrorCtrl from "../../helpers/fetchErrorCtrl"
import shouldFetch from "../../helpers/shouldFetch"
import {reloadEnums, getEnums} from "../actions"
import axios from 'axios'
import prepareFilters from "../../helpers/prepareFilters";

function request() {
    return {
        type: REQUEST_SUPPLIERS
    };
}

export function receive(data) {
    return {
        type: RECEIVE_SUPPLIERS,
        payload: data
    }
}

function failed(data) {
    return {
        type: ERROR_SUPPLIERS,
        errors: data
    }
}

function update(data, id, updateType) {
    return {
        type: UPDATE_SUPPLIERS,
        id,
        payload: data,
        updateType
    }
}

export function getSuppliers(params = {}, force = false) {
    return (dispatch, getState) => {
        if (shouldFetch(getState().suppliers, !force)) {
            dispatch(request())
            return axios({
                method: 'GET',
                url: fetchUrl + 'suppliers',
                params: prepareFilters(params, getState(), "suppliers")
            }).then(res => {
                dispatch(receive(res.data.data))
            }).catch(err => {
                const errors = fetchErrorCtrl(err)
                dispatch(failed(errors))
            })
        } else {
            return Promise.resolve()
        }
    }
}

export function getSupplier(id) {
    return (dispatch, getState) => {
        if (shouldFetch(getState().item)) {
            dispatch(requestItem('supplier'))
            return axios({
                method: 'GET',
                url: fetchUrl + 'suppliers/' + id
            }).then(res => {
                dispatch(receiveItem(res.data.data))
                return true
            }).catch(err => {
                const errors = fetchErrorCtrl(err)
                dispatch(failedItem(errors))
                return errors
            })
        } else {
            return Promise.resolve()
        }
    }
}

export function createSupplier(data, fromSelect = false) {
    return (dispatch, getState) => {
        if (shouldFetch(getState().item)) {
            if(!fromSelect){
                dispatch(requestItem())
            }
            return axios({
                method: 'POST',
                url: fetchUrl + 'suppliers',
                data
            }).then(res => {
                if(fromSelect){
                    dispatch(getEnums('suppliers', {}, true));
                    dispatch(reloadEnums('customersAndSuppliers'))
                    return res.data.data.id
                }else{
                    dispatch(receiveItem({}, 'message.item_created'))
                    dispatch(update(res.data.data, false, 'create'))
                    dispatch(reloadEnums('suppliers'))
                    dispatch(reloadEnums('customersAndSuppliers'))
                }
                return true
            }).catch(err => {
                const errors = fetchErrorCtrl(err)
                dispatch(failedItem(errors))
                return errors
            })
        } else {
            return Promise.resolve()
        }
    }
}

export function updateSupplier(data, id) {
    return (dispatch, getState) => {
        if (shouldFetch(getState().item)) {
            dispatch(requestItem('supplier'))
            return axios({
                method: 'PUT',
                url: fetchUrl + 'suppliers/' + id,
                data
            }).then(res => {
                dispatch(receiveItem(res.data.data, 'message.item_updated'))
                dispatch(update(res.data.data, id, 'update'))
                dispatch(reloadEnums('suppliers'))
                dispatch(reloadEnums('customersAndSuppliers'))
                return true
            }).catch(err => {
                const errors = fetchErrorCtrl(err)
                dispatch(failedItem(errors))
                return errors
            })
        } else {
            return Promise.resolve()
        }
    }
}

export function deleteSupplier(id) {
    return (dispatch, getState) => {
        if (shouldFetch(getState().item)) {
            dispatch(requestItem())
            return axios({
                method: 'DELETE',
                url: fetchUrl + 'suppliers/' + id
            }).then(res => {
                dispatch(receiveItem({}, 'message.item_deleted'))
                dispatch(update(res.data.data, id, 'delete'))
                dispatch(reloadEnums('suppliers'))
                dispatch(reloadEnums('customersAndSuppliers'))
                return true
            }).catch(err => {
                const errors = fetchErrorCtrl(err)
                dispatch(failedItem(errors))
                return errors
            })
        } else {
            return Promise.resolve()
        }
    }
}